import { Component, HostBinding } from "@angular/core";

@Component({
  template: "",
})
export abstract class PieChartComponent {
  @HostBinding("class.pie-chart__container") private readonly pieChartContainer = true;
}
